import React from "react";
import { numberWithComma } from "../../../utility";

const NewSchemePayout = ({
  listData,
  earningsAmount,
  setEarningsAmount,
  earningsRemarks,
  setEarningsRemarks,
  deductionAmount,
  setDeductionAmount,
  deductionRemarks,
  setDeductionRemarks,
  handleSetTDS,
  isReadOnly,
}) => {
  return (
    <>
      {/* Gratuity Details Section for New Scheme */}
      <table className="mt-4 w-full">
        <thead>
          <tr>
            <th
              colSpan="3"
              className="font-bold py-3 px-4 bg-[color:var(--color1)] text-white"
            >
              Gratuity Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-bold border py-3 px-4 text-center">
              Opening Balance
            </td>
            <td className="font-bold border py-3 px-4 text-center">
              In month
            </td>
            <td className="font-bold border py-3 px-4 text-center">
              Closing Balance
            </td>
          </tr>
          <tr>
            <td className="border py-3 px-4 text-center">
              {listData?.salary_payout?.gratuity_opening_balance ??
                listData?.gratuity_data?.opening_balance ??
                0}
            </td>
            <td className="border py-3 px-4 text-center">
              {listData?.salary_payout?.gratuity_in_month ??
                listData?.gratuity_data?.in_month ??
                0}
            </td>
            <td className="border py-3 px-4 text-center">
              {listData?.salary_payout?.gratuity_closing_balance ??
                listData?.gratuity_data?.closing_balance ??
                0}
            </td>
          </tr>
        </tbody>
      </table>

      {/* New Scheme 4-Quadrant Matrix */}
      <div className="flex flex-row mt-8">
        {/* Wages Table */}
        <table className="flex-1 mr-4">
          <thead>
            <tr>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Particulars
              </th>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="font-bold border py-3 px-4">Basic</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.basic)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">DA</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.da)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Total incl.</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.total_inclusive)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">HRA</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.hra)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Stat Bonus</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.stat_bonus)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Employer PF</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.employer_epf)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Total Excl.</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.total_exclusive)
                ) || 0}
              </td>
            </tr>
            <tr className="border">
              <td className="font-bold py-3 px-4 border-r">Amount</td>
              <td className="py-3 px-4 flex flex-col">
                <p className="text-sm mb-1">Value:</p>
                <input
                  onChange={(e) => setEarningsAmount(e.target.value)}
                  value={earningsAmount || ""}
                  placeholder="Enter Amount"
                  className="w-full focus:outline-none input mb-4"
                  type="number"
                  disabled={isReadOnly}
                />

                <p className="text-sm mb-1">Remarks:</p>
                <input
                  onChange={(e) => setEarningsRemarks(e.target.value)}
                  value={earningsRemarks || ""}
                  placeholder="Enter Remarks"
                  className="w-full focus:outline-none input"
                  type="text"
                  disabled={isReadOnly}
                />
              </td>
            </tr>
            <tr>
              <td className="font-bold border-t-2 border border-t-black py-3 px-4">
                Wages
              </td>
              <td className="border border-t-black border-t-2 py-3 px-4 font-bold">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.gross_salary)
                ) || 0}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Deduction Table */}
        <table className="flex-1 ml-4">
          <thead>
            <tr>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Deduction
              </th>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="font-bold border py-3 px-4">
                Professional Tax (P Tax)
              </td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.professional_tax)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">
                Provident Fund (PF)
              </td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.epf)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">ESIC</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.esic)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Stat Bonus</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.stat_bonus)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Employer PF</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.employer_epf)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Amount</td>
              <td className="border py-3 px-4">
                <p className="text-sm mb-1">Value:</p>
                <input
                  type="number"
                  className="input mb-4"
                  value={deductionAmount || ""}
                  onChange={(e) => setDeductionAmount(e.target.value)}
                  placeholder="Enter Amount"
                  disabled={isReadOnly}
                />

                <p className="text-sm mb-1">Remarks:</p>
                <input
                  onChange={(e) => setDeductionRemarks(e.target.value)}
                  value={deductionRemarks || ""}
                  placeholder="Enter Remarks"
                  className="w-full focus:outline-none input"
                  type="text"
                  disabled={isReadOnly}
                />
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4 border-t-black border-t-2">
                Total
              </td>
              <td className="font-bold border py-3 px-4 border-t-black border-t-2">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.total_deduction)
                ) || 0}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Contributions & Adjustments */}
      <div className="flex flex-row mt-8">
        {/* Contributions Table */}
        <table className="flex-1 mr-4">
          <thead>
            <tr>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Contributions
              </th>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="font-bold border py-3 px-4">Stat Bonus</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.stat_bonus)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Employer PF</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.employer_epf)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">
                Employer's State Insurance (ESI)
              </td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.employer_esic)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Employer's (MLWF)</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.employer_mlwf)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border-t-2 border border-t-black py-3 px-4">
                Total
              </td>
              <td className="border border-t-black border-t-2 py-3 px-4 font-bold">
                ₹{" "}
                {numberWithComma(
                  Math.round(
                    listData?.salary_payout?.total_employer_contribution
                  )
                ) || 0}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Adjustments Table */}
        <table className="flex-1 ml-4">
          <thead>
            <tr>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Adjustments
              </th>
              <th className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="font-bold border py-3 px-4">TDS</td>
              <td className="border py-3 px-4">
                <div className="flex items-center space-x-2">
                  <span>₹</span>
                  <input
                    type="text"
                    disabled={isReadOnly}
                    className="input"
                    onChange={handleSetTDS}
                    value={listData?.salary_payout?.tds || 0}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Adv.</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.advance)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4">Late Deduction</td>
              <td className="border py-3 px-4">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.late_deduction)
                ) || 0}
              </td>
            </tr>
            <tr>
              <td className="font-bold border py-3 px-4 border-t-black border-t-2">
                Total
              </td>
              <td className="font-bold border py-3 px-4 border-t-black border-t-2">
                ₹{" "}
                {numberWithComma(
                  Math.round(listData?.salary_payout?.total_adjustments)
                ) || 0}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NewSchemePayout;
